// App root
export const APP_ROOT = '/';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const ForgotPassword = '/forgotPassword';
export const ResetPassword = '/resetPassword';
export const CompleteAuth0Login = '/auth-resolve';
export const CompleteAuth0Logout = '/auth-logout';
export const EnterpriseConnection = '/enterprise/:connection';

// FBT --duplicated in the routes of feature -- remove them once all the cross feature depedency are resolved - TODO -sriram
export const FBT = '/fbt';
export const FBT_DRIVER = '/fbt/driver';
export const FBT_VEHICLE = '/fbt/driver/vehicle/:code';

export const FBT_EXEMPTION = '/fbt/driver/exemption';
export const FBT_EXEMPTION_ADD = '/fbt/driver/exemption/:leaseId/add';
export const FBT_EXEMPTION_EDIT =
  '/fbt/driver/exemption/:leaseId/edit/:exemptionId';

// User Management
export const USERS_MANAGEMENT = '/usermanagement';
export const USERS_MANAGEMENT_USER_LISTING = '/usermanagement/userlisting';
export const USERS_MANAGEMENT_USER_DETAIL = '/usermanagement/user/:id';

// Users Admin --duplicated in the routes of feature -- remove them once all the cross feature depedency are resolved - TODO -sriram
export const ADMIN = '/admin';
export const USER_LISTING = '/admin/userListing';
export const USER_FORM = '/admin/userListing/userForm';
export const ROLE_LISTING = '/admin/roleListing';
export const ROLE_FORM = '/admin/roleListing/roleForm/:id';
export const CONTENT_LISTING = '/admin/contentListing';
export const CONTENT_FORM = '/admin/contentListing/contentForm/:id';

// Accident Dashboard
export const ACCIDENT_MANAGEMENT_CLAIMS = '/accident-management/dashboard/:id';

// Telematics Dashboard
export const TELEMATICS_DASHBOARD = '/telematics/dashboard/:path';

// Fleet management
export const FLEET = '/fleet';

// Corporate Quote
export const CQ_ROOT = `${FLEET}/corporate-quote`;
export const CQ_CREATE = `${CQ_ROOT}/create`;
export const CQ_CREATE_QUESTIONS = `${CQ_CREATE}/questions`;
export const CQ_CREATE_SOURCE = `${CQ_CREATE}/source`;
export const CQ_CREATE_VEHICLE = `${CQ_CREATE}/vehicles`;
export const CQ_CREATE_OPTIONS = `${CQ_CREATE}/options`;
export const CQ_CREATE_DECLINED = `${CQ_CREATE}/declined`;
export const CQ_CREATE_DELIVERY = `${CQ_CREATE}/delivery`;
export const CQ_CREATE_LEASE = `${CQ_CREATE}/lease`;
export const CQ_CREATE_SUMMARY = `${CQ_CREATE}/summary`;
export const CQ_CREATE_SUBMITTED = `${CQ_CREATE}/submitted`;

export const CQ_APPROVAL = `${CQ_ROOT}/approval`;
export const CQ_MYQUOTE = `${CQ_ROOT}/myquote`;

export const TRANSFERS_ROOT = `${FLEET}/transfers`;
export const TRANSFERS_VEHICLE = `${TRANSFERS_ROOT}/vehicle`;
export const TRANSFERS_DRIVER = `${TRANSFERS_ROOT}/driver`;

// Company
export const COMPANY_HIERARCHY = `${FLEET}/company-hierarchy`;

// Profile
export const PROFILE = '/profile';

// Bookmarks
export const MY_BOOKMARKS = '/my-bookmarks';

// Fuel Cards
export const FUEL_CARDS = '/fuel-cards';

// Inisghts
export const INSIGHTS = '/insights';
export const INSIGHTSDASHBOARD = '/insights/dashboard';
export const SUMMARYDETAIL = '/summary/:id';

export const REPORTS = '/reports';
export const REPORTS_VIEW = `${REPORTS}/view`;

export const REPORT_DETAIL = `${REPORTS_VIEW}/:id`;
export const REPORT_DETAIL_YELLOWFIN = `${REPORT_DETAIL}/yellowfin`;
export const REPORT_YELLOWFIN = `${REPORTS}/yellowfin/:id`;
export const REPORT_POWERBI_EMBED = `${REPORTS}/powerbi/:embedtype/:id`;

export const REPORTS_BUILDER = `${REPORTS}/build`;
export const RB_BUSINESS_REPORTS = `${REPORTS_BUILDER}/business`;
export const RB_MY_REPORTS = `${REPORTS_BUILDER}/user`;
export const RB_LEGACY_REPORTS = `${REPORTS_BUILDER}/legacy`;
export const RB_REPORT_EDIT = `${REPORTS_BUILDER}/:category/:id`;

export const USER_EDIT = '/adminnew/user/:id';
export const USER_NEW = '/adminnew/user';
export const ADMINNEW = '/adminnew';
export const USER_BULK_UPLOAD = '/adminnew/import/users';

export const TABLEDETAIL = '/insights/reports/table/:id';
export const TABLEDETAILDRIVER = '/insights/reports/driver/table/:id';
export const TABLEDETAIL_PARAM = '/insights/reports/table/:id?report=:report';

export const FBT_DRIVER_REPORT = '/fbt/driver/report/:id';

// {type: business / my}
// export url with saved id /api.s/reports/:id.csv -> backend url
// export with param
// endpoint api post param

export const CORPORATE_QUOTE_WORKFLOW_SETUP =
  '/admin/corporate-quote/workflow-setup';
// Corporate Quote WorkFlow
export const Quote_Summary = '/quote_summary';

// Notification center
export const NOTIFICATION = '/notification';
export const NOTIFICATION_CENTER = `${NOTIFICATION}/notification-center`;
export const NOTIFICATION_SETTINGS = `${NOTIFICATION}/notification-settings`;

// Home
export const HOME = FBT_DRIVER;

// ERROR
export const HTTP_ERROR_HANDLE = '/error';

// DRIVER PROFILE
export const DASHBOARD_PROFILE = '/v1/dashboard/:dashtype/:countryCode/:refid';
export const DASHBOARD_PROFILE_ID = '/dashboard/:dashtype/:countryCode/:refid';
// Global Search
export const SEARCH_RESULT = '/search/result';



// WEBPACK FOOTER //
// ./src/routes/const.js